import React from 'react';
import { Tooltip } from '@/components/tooltip';

interface ColumnTooltipIconProps {
  label: string;
  text: string | null;
}

export function ColumnTooltipIcon({ label, text }: ColumnTooltipIconProps) {
  if (!text) {
    return null;
  }

  return (
    <span role="presentation">
      <Tooltip title={label} text={text} zIndex={10000000} />
    </span>
  );
}
